import { render, staticRenderFns } from "./ProductButton.vue?vue&type=template&id=17bc65ef&scoped=true"
import script from "./ProductButton.vue?vue&type=script&lang=js"
export * from "./ProductButton.vue?vue&type=script&lang=js"
import style0 from "./ProductButton.vue?vue&type=style&index=0&id=17bc65ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc65ef",
  null
  
)

export default component.exports